// alerts types
export const ESCALATION = 'ESCALATION';
export const ESCALATION_PARTNER = 'ESCALATION_PARTNER';
export const POLICY = 'POLICY';
export const GUIDE = 'GUIDE';
export const PRODUCTS = 'PRODUCTS';
export const SALE_PROMO = 'SALE_PROMO';
// all type used for see all page
export const ALL_ALERTS = 'ALL_ALERTS';

export const alertsTypesList = [ESCALATION, POLICY, GUIDE, PRODUCTS, SALE_PROMO];

export const alertsTypesMap = {
  ESCALATION: { value: ESCALATION, label: 'Escalation', icon: '/images/alert-icon-escalation.svg' },
  ESCALATION_PARTNER: {
    value: ESCALATION_PARTNER,
    label: 'Escalation Partner',
    icon: '/images/alert-icon-escalation.svg',
  },
  POLICY: { value: POLICY, label: 'Policy', icon: '/images/alert-icon-policy-change.svg' },
  GUIDE: { value: GUIDE, label: 'Guide', icon: '/images/alert-icon-process.svg' },
  PRODUCTS: { value: PRODUCTS, label: 'Product', icon: '/images/alert-icon-product.svg' },
  SALE_PROMO: { value: SALE_PROMO, label: 'Sale/Promo', icon: '/images/alert-icon-sales-promo.svg' },
};

export const alertStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  DELETED: 'DELETED',
};

// old flag system
export const alertActionType = {
  NEW: 'NEW',
  UPDATE: 'UPDATE',
  DELETED: 'DELETED',
};

// blockType types
export const NON_BLOCKING = 'NON_BLOCKING';
export const BLOCK_ONCE = 'BLOCK_ONCE';
export const ALWAYS_BLOCK = 'ALWAYS_BLOCK';
export const BLOCK_DAILY = 'BLOCK_DAILY';
export const BLOCK_WEEKLY = 'BLOCK_WEEKLY';

export const blockTypesMap = {
  NON_BLOCKING: { label: 'Non-blocking', value: NON_BLOCKING },
  BLOCK_ONCE: { label: 'Block once', value: BLOCK_ONCE },
  ALWAYS_BLOCK: { label: 'Always block', value: ALWAYS_BLOCK },
  BLOCK_DAILY: { label: 'Block daily', value: BLOCK_DAILY },
  BLOCK_WEEKLY: { label: 'Block weekly', value: BLOCK_WEEKLY },
};

// readStatus types
export const NEW = 'NEW';
export const READ = 'READ';
export const UPDATED = 'UPDATED';
